import http from './http'
import config from '@/utils/config'
//
/**
 *  @parms resquest 请求地址
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */

const home = `/Home`
function workBenchOverview(params) {
  return http.get(`${home}/workBenchOverview`, params)
}
function getWorkOrderPages(params) {
  return http.post(`${home}/getWorkOrderPages`, params)
}
function getMessagePages(params) {
  return http.post(`${home}/getMessagePages`, params)
}
function getSchedulePages(params) {
  return http.post(`${home}/getSchedulePages`, params)
}
function readMessage(params) {
  return http.put(`${home}/readMessage`, params)
}
function completedSchedule(params) {
  return http.put(`${home}/completedSchedule`, params)
}
function customerCompanyStatistics(params) {
  return http.get(`${home}/customerCompanyStatistics`, params)
}
function customerFilesStatistics(params) {
  return http.post(`${home}/customerFilesStatistics`, params)
}
function customerWorkOrderStatistics(params) {
  return http.post(`${home}/customerWorkOrderStatistics`, params)
}
function customerMBLStatistics(params) {
  return http.post(`${home}/customerMBLStatistics`, params)
}
function customerCompanyLiveStatistics(params) {
  return http.post(`${home}/customerCompanyLiveStatistics`, params)
}
function customerCompanyList(params) {
  return http.get(`${home}/customerCompanyList`, params)
}
function customerHoldStatistics(params) {
  return http.post(`${home}/customerHoldStatistics`, params)
}
function customerHoldCompanyStatistics(params) {
  return http.post(`${home}/customerHoldCompanyStatistics`, params)
}
function operationISFSyncStatistics(params) {
  return http.post(`${home}/operationISFSyncStatistics`, params)
}
function operationComfirmMBLStatistics(params) {
  return http.post(`${home}/operationComfirmMBLStatistics`, params)
}
function operationFilesStatistics(params) {
  return http.post(`${home}/operationFilesStatistics`, params)
}
function operationMBLStatistics(params) {
  return http.post(`${home}/operationMBLStatistics`, params)
}
function operationPicStatistics(params) {
  return http.post(`${home}/operationPicStatistics`, params)
}
function operationHoldRecordStatistics(params) {
  return http.post(`${home}/operationHoldRecordStatistics`, params)
}
function customerMBLHoldRecordStatistics(params) {
  return http.post(`${home}/customerMBLHoldRecordStatistics`, params)
}
function customerOrderOnlineStatistics(params) {
  return http.post(`${home}/customerOrderOnlineStatistics`, params)
}
function customerImportantCompanyStatistics(params) {
  return http.post(`${home}/customerImportantCompanyStatistics`, params)
}
function customerCompanyStatistics1(params) {
  return http.post(`${home}/customerCompanyStatistics1`, params)
}
function saleGoleStatistics(params) {
  return http.post(`${home}/SaleGoleStatistics`, params)
}
function companyRevenueTopStatistics(params) {
  return http.post(`${home}/companyRevenueTopStatistics`, params)
}
function saleAmountStatistics(params) {
  return http.post(`${home}/SaleAmountStatistics`, params)
}
function salesAmountTopStatistics(params) {
  return http.post(`${home}/SalesAmountTopStatistics`, params)
}

const operationsReport = `/operationsReport`

function getOperationsReport(params) {
  return http.get(`${operationsReport}/getOperationsReport`, params)
}
function sendOperationsReportToEmail(params) {
  return http.post(`${operationsReport}/sendOperationsReportToEmail`, params)
}

export {
  workBenchOverview,
  getMessagePages,
  getSchedulePages,
  readMessage,
  completedSchedule,
  getWorkOrderPages,
  getOperationsReport,
  sendOperationsReportToEmail,
  customerCompanyStatistics,
  customerFilesStatistics,
  customerWorkOrderStatistics,
  customerMBLStatistics,
  customerCompanyLiveStatistics,
  customerCompanyList,
  customerHoldStatistics,
  customerHoldCompanyStatistics,
  operationISFSyncStatistics,
  operationComfirmMBLStatistics,
  operationFilesStatistics,
  operationMBLStatistics,
  operationPicStatistics,
  operationHoldRecordStatistics,
  customerMBLHoldRecordStatistics,
  customerOrderOnlineStatistics,
  customerImportantCompanyStatistics,
  customerCompanyStatistics1,
  saleGoleStatistics,
  companyRevenueTopStatistics,
  saleAmountStatistics,
  salesAmountTopStatistics
}
